import React from "react";
import useTranslationJobs from "../useTranslationJobs";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import JobMaxCommissionTip from "./JobMaxCommissionTip";
import JobAverageCommissionTip from "./JobAverageCommissionTip";
import JobSimilarJobsCommissionTip from "./JobSimilarJobsCommissionTip";
import "./JobSaveCommissionTip.scss"

export default function JobSaveCommissionTip(props) {
  const { similarJobs, jobGlobalMaxCommission, jobGlobalAverageCommission } =
    props;

  const { t, loading: tLoading } = useTranslationJobs();
  useShowLoader(tLoading, "JobSaveCommissionTip");

  return (
    <>
      <div className="JobSaveCommissionTip">
        <Row>
          <Col>
            <h2>{t("jobs:employers_job_save_tip_title")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <JobSimilarJobsCommissionTip similarJobs={similarJobs} />
          </Col>
        </Row>
        <Row>
          <Col>
            <JobAverageCommissionTip jobGlobalAverageCommission={jobGlobalAverageCommission} similarJobs={similarJobs} />
            <JobMaxCommissionTip jobGlobalMaxCommission={jobGlobalMaxCommission} similarJobs={similarJobs} />
          </Col>
        </Row>
        <Row>
          <Col>
            {t("jobs:employers_job_save_tip_msg2")}
          </Col>
        </Row>
      </div>
    </>
  );
}
